/** @jsx jsx */
import { jsx } from 'theme-ui';
import PropTypes from 'prop-types';

const firstColumn = {
  width: [null, null, '50%'],
  '> div': {
    paddingBottom: '6rem',
  },
};

const secondColumn = {
  width: ['calc(100% - 3rem)', 'calc(100% - 5.6rem)', '50%'],
  maxWidth: [null, '63%', '50%'],
  margin: ['0 auto', '0 0 0 28px', '0'],
  '> div': {
    padding: ['6rem 11.5% 5rem', null, '11.4rem 6.4rem'],
  },
};

export const DualColumnContainer = ({ bg, ...props }) => (
  <div
    sx={{
      paddingBottom: ['10rem', null, 0],
      bg,
      display: 'flex',
      flexFlow: ['column nowrap', null, 'row nowrap'],
      '> div:first-of-type': {
        ...firstColumn,
      },
      '> div:nth-of-type(2)': {
        ...secondColumn,
      },
    }}
    {...props}
  />
);

DualColumnContainer.propTypes = {
  bg: PropTypes.string,
};

DualColumnContainer.defaultProps = {
  bg: null,
};
